import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';

@Component({
  selector: 'mat-icon-dehoniane',
  templateUrl: './mat-icon-dehoniane.component.html',
  styleUrls: ['./mat-icon-dehoniane.component.css']
})
export class MatIconDehonianeComponent implements OnInit {

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('dehoniane-logo', sanitizer.bypassSecurityTrustResourceUrl('assets/dehoniane24.svg'));
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/mat-icon-dehoniane/mat-icon-dehoniane.component.ts